import { Control, Controller } from 'react-hook-form';
import { MenuItem, TextField, StandardTextFieldProps } from '@mui/material';

import { Container } from './styles';

export interface SelectControlledProps extends StandardTextFieldProps {
  control: Control;
  name: string;
  options: {
    label: string;
    value: string;
  }[];
}

export const SelectComponent = ({
  name,
  control,
  sx,
  options,
  ...rest
}: SelectControlledProps) => {
  return (
    <Container sx={sx}>
      <Controller
        name={name}
        control={control}
        render={({
          field: { value, onChange, onBlur, ref },
          fieldState: { error },
        }) => (
          <TextField
            value={value}
            select
            ref={ref}
            onBlur={onBlur}
            onChange={onChange}
            error={!!error}
            helperText={error ? error.message : null}
            {...rest}
          >
            {options.map(o => (
              <MenuItem value={o.value}>{o.label}</MenuItem>
            ))}
          </TextField>
        )}
      />
    </Container>
  );
};
